import { type Timeframe, TIMEFRAME_SECONDS, type Venue } from "@trader/shared/MarketData"

// When a bar has closed, as the server's replay clock counts it: an intraday bar
// one timeframe after it opens; a daily bar (stamped with its session's open) at
// the close of the day's last session. A chart following a replay shows only
// bars closed at the replay's virtual time, so it never shows the future.

const minutesOf = (hhmm: string): number => {
  const [hours = 0, minutes = 0] = hhmm.split(":").map(Number)
  return hours * 60 + minutes
}

/** Seconds from the first session's open to the last one's close (NSE: 6h15m). */
const sessionSpanSeconds = (venue: Venue): number => {
  const first = venue.sessions[0]
  const last = venue.sessions.at(-1)
  if (first === undefined || last === undefined) return TIMEFRAME_SECONDS["1D"]
  const span = (minutesOf(last.close) - minutesOf(first.open)) * 60
  return span > 0 ? span : TIMEFRAME_SECONDS["1D"]
}

export const barCloseTime = (venue: Venue, timeframe: Timeframe, barTime: number): number =>
  barTime + (timeframe === "1D" ? sessionSpanSeconds(venue) : TIMEFRAME_SECONDS[timeframe])

/** How many of `bars` (oldest first) have closed by `end`. */
export const closedCount = (bars: ReadonlyArray<{ readonly time: number }>, end: number, closeOf: (time: number) => number): number => {
  let low = 0
  let high = bars.length
  // Close times grow with open times, so the closed bars are a prefix.
  while (low < high) {
    const mid = (low + high) >>> 1
    if (closeOf(bars[mid]!.time) <= end) low = mid + 1
    else high = mid
  }
  return low
}
